import React from 'react';
import { compose } from 'redux';
import { navigate } from 'gatsby';

import Link from '../../Link';
import RedemptionOption from '../../account/forms/loyalty/RedemptionOption';
import withAccount from '../../../containers/plugins/withAccount';
import withLoyalty from '../../../containers/plugins/withLoyalty';

const Loyalty = ({
  account,
  campaigns,
  customer,
  loyalty,
  open,
  redemptionOptions,
  site,
}) => {
  // prettier-ignore
  const createAccountCampaign = Array.isArray(campaigns)
    ? campaigns?.find((campaign) => campaign.type === 'CreateAccountCampaign')
    : [];
  // prettier-ignore
  const pointsForPurchaseCampaign = Array.isArray(campaigns)
    ? campaigns?.find((campaign) => campaign.type === 'PointsForPurchasesCampaign')
    : [];

  const options =
    Array.isArray(redemptionOptions) && account
      ? redemptionOptions.map((option) => (
          <RedemptionOption
            key={option.id}
            customer={customer}
            loyalty={loyalty}
            onCopy={() => loyalty.redemptionOptions(account.email)}
            onRedemption={() => loyalty.customers(account.email)}
            redemptionOption={option}
          />
        ))
      : [];

  return (
    <div
      className={`util__loyalty-drawer ${
        account ? 'util__loyalty-drawer--logged-in' : ''
      } ${open ? 'util__loyalty-drawer--open' : ''}`}
    >
      <div className="util__loyalty-drawer-wrapper">
        {account && customer ? (
          <>
            <header>
              <h2>{account.firstName}</h2>
              <h2>{customer.points_balance} points</h2>
            </header>
            <div className="loyalty-drawer__redemption-options-wrapper">
              {redemptionOptions.length > 0 ? (
                <ul className="loyalty-drawer__redemption-options">
                  {options}
                </ul>
              ) : (
                <h2>Place orders to get rewards</h2>
              )}
            </div>
          </>
        ) : (
          <>
            <header>
              💰 Earn {pointsForPurchaseCampaign?.reward_text} you spend
            </header>
            <div className="loyalty-drawer__redemption-options-wrapper">
              <ul className="loyalty-drawer__redemption-options">
                <li className="loyalty__redemption-option">
                  <Link
                    to={{ siteUID: site.siteUID, path: 'account/register' }}
                    site={site}
                  >
                    <button className="redemption-option__redeem">
                      <span>
                        Join now and earn {createAccountCampaign?.reward_text}
                      </span>
                    </button>
                  </Link>
                </li>
              </ul>
            </div>
            <footer>
              <span>Already a member?</span>{' '}
              <Link
                to={{
                  siteUID: site.siteUID,
                  path: 'account',
                }}
                site={site}
              >
                Log in
              </Link>
            </footer>
          </>
        )}
      </div>
    </div>
  );
};

export default compose(withAccount, withLoyalty)(Loyalty);
